export const ReplacePlantConstant = {
    API: 'ReplacePlant'
}

export const ReplacePlantAPIConstant = {
    REPLACEPLANT: ReplacePlantConstant.API +'/ReplacePlant',
    GET_REPLACE_PLANT_NAME :  ReplacePlantConstant.API +'/GetPlantNamesWithDetails'
 }